<div class="flex flex-col">
    <div class="flex justify-between mb-1">
        <h3 class="site-name-color">{{dashboardService.translate('VERIFICATION')}}</h3>
        <span class="flex items-center " mat-dialog-close mat-icon-button
            style="cursor: pointer">
            <mat-icon [svgIcon]="'custom:close'"></mat-icon>
        </span>
    </div>
    <p>{{'In this window, you can search for a specific verification status you want to see.'}}
    </p>
</div>
<hr class="w-full my-4">
<div class=" mt-3 h-50  overflow-y-auto ">
    <div class="text-left py-2 border-b border-gray-200 cursor-pointer">
        <mat-checkbox class="py-2 pl-5 w-full"  *ngFor="let verification_type of verification_status_options"  [checked]="isChecked(verification_type)"
        (change)="onSectionSelect(verification_type,$event.checked)">{{dashboardService.translate(verification_type)}}</mat-checkbox>
    </div>


    <div class=" mb-4 mt-3 mr-4 flex justify-end">
        <button (click)="onSubmitClick()" class="bg-[#142653] hover:bg-[#0e1836] text-white font-bold py-2 px-4 rounded">
            {{dashboardService.translate('Submit')}}
        </button>
    </div>
</div>
